import React from 'react';
import SEO from '../../components/ui/SEO';
import ServicePageTemplate from '../../components/ui/ServicePageTemplate';
import { servicePages } from '../../data/services';
export default function Neurodevelopmental() {
  return <main className="min-h-screen bg-white" data-id="element-1140" data-mp="1x2g4hx0s7xhi">
      <SEO title="ADHD Medico-Legal Assessment | Neurodevelopmental Reports" description="Independent ADHD and neurodevelopmental medico-legal assessments for criminal, civil, employment and family proceedings. Request a fee quote." path="/services/neurodevelopmental" keywords={['ADHD medico-legal assessment', 'ADHD assessment for court', 'neurodevelopmental expert report']} imageAlt="ADHD and neurodevelopmental medico-legal assessments" schema={{
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'ADHD and Neurodevelopmental Assessments',
      serviceType: 'Neurodevelopmental assessment',
      url: 'https://medicolegal-psychiatry.co.uk/services/neurodevelopmental',
      areaServed: {
        '@type': 'AdministrativeArea',
        name: 'England and Wales'
      },
      provider: {
        '@type': 'Organization',
        name: 'Medicolegal Psychiatry',
        url: 'https://medicolegal-psychiatry.co.uk'
      },
      audience: {
        '@type': 'Audience',
        name: 'Legal professionals'
      },
      description: 'Medico-legal assessment of ADHD and other neurodevelopmental conditions and their relevance to legal proceedings.'
    }} data-id="element-1141" data-mp="1s2k03wo6a41f" />
      <ServicePageTemplate content={servicePages.neurodevelopmental} data-id="element-1142" data-mp="23g2228lftao0" />
    </main>;
}